import { render, staticRenderFns } from "./TalkgroupObject.vue?vue&type=template&id=8261d0da&scoped=true"
import script from "./TalkgroupObject.vue?vue&type=script&lang=js"
export * from "./TalkgroupObject.vue?vue&type=script&lang=js"
import style0 from "./TalkgroupObject.vue?vue&type=style&index=0&id=8261d0da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8261d0da",
  null
  
)

export default component.exports